export default "__VITE_ASSET__BgoPJiOi__"